import * as React from "react";
import { TextField, BooleanField } from "react-admin";
import { subResourceList } from "../_subresource";
import { FrDateField } from "../../components/FrDateField";

// GET /pro/{proId}/exercises — suppression : DELETE /pro/{proId}/exercises/{id}.
export default {
  list: subResourceList({
    parentParam: "proId",
    parentLabel: "ID pro",
    canDelete: true,
    children: [
      <TextField key="title" source="title" label="Titre" />,
      <TextField key="category" source="category" label="Catégorie" />,
      <BooleanField key="active" source="active" label="Actif" />,
      <FrDateField key="updatedAt" source="updatedAt" label="Modifié le" showTime />,
    ],
  }),
};
